import PaymentMethodModal from './PaymentMethodModal'

export default PaymentMethodModal
